import React from "react";
import RateAppointmentContainer from "../../container/participant/rateAppointment/rateAppointmentContainer";
import RateAppointmentContext from "../../container/participant/rateAppointment/context/rateAppointmentContext";

const RateAppointment = (): React.JSX.Element => (
  <RateAppointmentContext>
    <RateAppointmentContainer />
  </RateAppointmentContext>
);

export default RateAppointment;
